import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

const SETTINGS_DOC_ID = 'siteConfig';

export const getGlobalSettings = async () => {
  try {
    const docRef = doc(db, 'settings', SETTINGS_DOC_ID);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      // Default settings
      const defaultSettings = { title: 'ALL BLACK SCREEN', maintenanceMode: false };
      await setDoc(docRef, defaultSettings);
      return defaultSettings;
    }
  } catch (error) {
    console.error("Error fetching settings:", error);
    return { title: 'ALL BLACK SCREEN', maintenanceMode: false };
  }
};

export const updateGlobalSettings = async (updates) => {
  try {
    const docRef = doc(db, 'settings', SETTINGS_DOC_ID);
    await setDoc(docRef, updates, { merge: true });
    return true;
  } catch (error) {
    console.error("Error updating settings:", error);
    return false;
  }
};

export const subscribeToSettings = (callback) => {
  const docRef = doc(db, 'settings', SETTINGS_DOC_ID);
  return onSnapshot(docRef, (docSnap) => {
    if (docSnap.exists()) {
      callback(docSnap.data());
    } else {
      callback({}); // Return empty if doesn't exist yet
    }
  }, (error) => {
    console.error("Error subscribing to settings:", error);
    callback({}); // unblock UI on error
  });
};
